import { render, staticRenderFns } from "./welcome-layout.vue?vue&type=template&id=cde24428"
import script from "./welcome-layout.vue?vue&type=script&lang=js"
export * from "./welcome-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports